import React from "react";
import { Camera } from "lucide-react";
import { company } from "../data/mock";

const STYLES = {
  dark: "bg-white/10 border border-white/30 text-white hover:bg-white/20 backdrop-blur",
  light: "bg-white border border-[#3b9dff]/40 text-[#0a1f44] hover:bg-[#eef4ff]",
};

export const TextPhotoButton = ({ variant = "light", testId = "text-photo-btn", className = "", href = company.photoSms, label = "Text us a photo of your wall" }) => (
  <a
    href={href}
    data-testid={testId}
    className={`inline-flex items-center gap-2 px-5 py-3 rounded-full font-semibold text-sm transition-colors ${STYLES[variant]} ${className}`}
  >
    <Camera className="w-4 h-4 text-[#3b9dff]" />
    {label}
    <span className="hidden sm:inline font-normal opacity-80">· {company.phone}</span>
  </a>
);
